import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../data/images';
import { ritualSteps } from '../data/ritual';
export function About() {
  return <>
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-20" data-id="element-374" data-mp="29jn9fhppl8em">
        <div className="lg:col-span-6" data-id="element-375" data-mp="2eigld5pckrco">
          <p className="text-sm font-medium text-clay" data-id="element-376" data-mp="2ejhwfa6d5due">Amira — betekenis: prinses</p>
          <h1 className="mt-3 text-4xl font-semibold tracking-display sm:text-6xl" data-id="element-377" data-mp="329ccs1pw5kje">Terug naar de basis</h1>
          <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted" data-id="element-378" data-mp="3762qwji4y626">
            <p data-id="element-379" data-mp="2sawjpt7b0179">
              Amira groeide op in Aït Baha, tussen de heuvels van de Anti-Atlas. Cosmetica bestond daar niet uit chemische producten
              uit kastjes, maar uit henna, arganolie en gedroogde planten — gemengd door haar oma.
            </p>
            <p data-id="element-380" data-mp="1gxauk81g1zlq">
              Op de souk leerde ze de zeep, kruiden, oliën en geurende waters kennen. Later zag ze diezelfde ingrediënten terug in
              hedendaagse beautyproducten, verpakt in grote verhalen en grote beloftes.
            </p>
            <p className="text-ink" data-id="element-381" data-mp="1pjqjycrzgjxr">
              Een product hoef je niet mooier te maken dan het is. Je moet weten wat het is, wat het doet en hoe je het gebruikt.
            </p>
          </div>
        </div>
        <img src={images.story} alt="Twee generaties mengen henna in een terracotta schaal" className="aspect-[4/5] w-full rounded-3xl object-cover lg:col-span-6" data-id="element-382" data-mp="1yhtwijkzq6df" />
      </section>

      <section id="ritueel" className="bg-surface" data-id="element-383" data-mp="28gi38m7iyz1t">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-24" data-id="element-384" data-mp="28fqf1wg9c3lk">
          <div className="lg:col-span-5" data-id="element-385" data-mp="2i7cslzg2ierh">
            <div className="lg:sticky lg:top-36" data-id="element-386" data-mp="2i8nsvpab14du">
              <h2 className="text-3xl font-semibold tracking-display sm:text-5xl" data-id="element-387" data-mp="2w75d3d103yr0">Het ritueel in 9 stappen</h2>
              <p className="mt-4 text-lg text-muted" data-id="element-388" data-mp="2r8avufiomi90">Geïnspireerd op de hammam. Elke stap heeft een doel en een product dat precies dat doet.</p>
              <Link to="/product/hammam-ritueel-set" className="mt-8 inline-flex h-14 items-center whitespace-nowrap rounded-full bg-ink px-7 text-base font-medium text-canvas transition-colors duration-150 hover:bg-clay" data-id="element-389" data-mp="1ow7ltosfxdm3">
                Shop de Hammam Ritueel Set
              </Link>
            </div>
          </div>
          <ol className="lg:col-span-7" data-id="element-390" data-mp="27lxfg8kgvtcf">
            {ritualSteps.map((s, i) => <li key={s.title} className="grid grid-cols-[3rem_1fr] gap-4 border-t border-line py-6 last:border-b" data-id="element-391" data-mp="2cjyyithw7snw" data-mpi={i}>
                <span className="text-2xl font-semibold text-clay tabular-nums" data-id="element-392" data-mp="2glkjl24kzd96">{i + 1}</span>
                <div data-id="element-393" data-mp="2ll5hrabxfhku">
                  <h3 className="text-xl font-semibold tracking-tight" data-id="element-394" data-mp="2ljm29ly3hak4">{s.title}</h3>
                  <p className="mt-1 text-muted" data-id="element-395" data-mp="m8uo4fykdvzo">{s.text}</p>
                  {s.products.length > 0 && <p className="mt-2 text-sm text-ink" data-id="element-396" data-mp="r6cqfni2tcyp">{s.products.join(' · ')}</p>}
                </div>
              </li>)}
          </ol>
        </div>
      </section>
    </>;
}